<template>
  <main class="container my-40">
    <div class="row">
      <StandCard v-for="(stand, key) in stands" :key="key" :stand="stand"
        :standAvailable="!(!stand.description && stand.photos.length == 0 && !stand.video)" />
    </div>
    <StandModal :stand="stand" v-if="showStandModal" :showCVForm="false" />
    <ExhibitorsCarousel />
  </main>
</template>

<script>
import ExhibitorsCarousel from "@/components/ExhibitorsCarousel.vue";
import StandModal from "@/components/StandModal.vue";
import StandCard from "@/components/StandCard.vue";
import _ from "lodash";
import axios from "axios";

export default {
  components: { ExhibitorsCarousel, StandCard, StandModal },
  data() {
    return {
      stands: [],
      stand: null,
      showStandModal: false,
      standAvailable: false
    };
  },
  beforeCreate() {
    axios
      .get(`${process.env.VUE_APP_REDES_ENDPOINT}/fairs/stands`, {
        withCredentials: false,
      })
      .then((response) => {
        this.stands = _.shuffle(response.data.stands);
      });
  },
  methods: {
    handleModal(stand) {
      if (!stand.description && stand.photos.length == 0 && !stand.video) {
        return
      }
      this.stand = stand;
      this.showStandModal = true;
    },
  }
};
</script>
